/* tslint:disable:typedef-whitespace no-trailing-whitespace no-inferrable-types import-spacing */

import { ElementRef }         from '@angular/core';

import { Dialog }             from './dialog';
import { Logger }             from '@/util/logger';
import { IdeService         } from '@/services/ide.service';
import { IValidatorCallBack } from './i.validator.call.back';
import { IOkCallBack        } from './i.ok.call.back';
import { SimulationJob }      from '@/models/sim/simulation.job';
import { SimpleSimJob }       from '@/models/sim/simple.sim.job';

import * as $                 from 'jquery';

import {SimConfig} from '@/models/sim/sim.config';
import {Blob as FileBlob, BlobType} from "@/models/blob";
import {basename, bytesToSize, empty} from "@/util/util";

/**
 *
 * @class BlobHistoryDialog
 *
 * @brief helper dialog to show the complete set of snapshots for a blob
 *
 * - - - - - - - - - - - - - - - - - - -
 * @author    Michael Garvin (mike.garvin@ironroad.ca)
 * @date      February 2022
 *
 */
export class BlobHistoryDialog extends Dialog {

  /** the blob we are displaying the history of */
  private key: string    = '';

  /** the meta data object for each snapshot of this blob */
  private history: any[] = [];

  /** standard constructor, allow for partial alert to be given */
  constructor(
    host: ElementRef
  ) {

    super(host);

    this.title     = 'Blob Snapshot History';
    this.icon      = '<i class="fas fa-info"></i>';

    Logger.debug('[BlobHistoryDialog] setting up...');

    this.hasOk     = true;
    this.hasCancel = false;

  }

  /** dialog has been opened */
  public open(validator?: IValidatorCallBack, success?: IOkCallBack, options?: any) {

    this.validator = validator ? validator : null;
    this.success   = success   ? success   : null;

    this.hasOk     = true;
    this.hasCancel = false;

    if (options) {

      if (options.key) {

        this.key = options.key;
      }

      if (options.history) {

        this.history = options.history;
      }
    }

    Logger.debug('[BlobHistoryDialog] opening:', this.history);

    const body = $(this.host).find('.modal-body');

    const modal = $(this.host).parent('.modal');

    let html = `<div class="blob-history-wrapper">`;

    /* show the header, common info for all the instances:
     *
     *  <icon> | <basename> + <ext>
     *  ------------------------------------
     *  <guid> | <# instances>
     *
     */

    let icon: string   = FileBlob.iconOfType(BlobType.File);
    let bName: string  = '<No File>';
    let guid: string   = '';
    let iCount: number = 0;

    if (!empty(this.key)) {

      icon  = FileBlob.iconOfType(FileBlob.impliedType(this.key));
      bName = basename(this.key);
    }

    if (this.history.length > 0) {

      guid   = this.history[0].guid;
      iCount = this.history.length;
    }

    html += `<div class="blob-history-header">`;

    html += `  <div class="blob-history-header-upper">`;
    html += `  <img style="display: inline-block;" src="assets/images/blob-icons/${icon}">`;
    html += `  <h2 style="margin-left: 12px; display: inline-block;">${bName}</h2>`;
    html += `  </div>`;

    html += `  <div class="blob-history-header-lower">`;
    html += `  <h4 style="display: inline-block;"><i>${guid}</i></h4>`;
    html += `  <h4 style="margin-left: 12px; display: inline-block;">[${iCount}]</h4>`;
    html += `  </div>`;

    html += `</div>`;

    /*
     * for each item in the history, we're expepcting:
     *
     *   oid	37
     *   data	"/var/www/html/blobs/886a4ba2-e513-4bec-b082-5746db88af75/upload:0:level_1_test_5_stop_city.json"
     *   size	109597
     *   key	"/users/mgarvin/level_1_test_5_stop_city.json"
     *   guid	"886a4ba2-e513-4bec-b082-5746db88af75"
     *   name	"level_1_test_5_stop_city.json"
     *   type	"json"
     *   tags	[]
     *   version	""
     *   instance	0
     *   owner	"mgarvin"
     *   blob_sha	"c21f419267485d1cba2a333e3dfd3ec3c3908c71"
     *   created	"2021-12-23 19:53:14"
     *   modified	"2021-12-23 19:53:14"
     *   meta	"/var/www/html/blobs/886a4ba2-e513-4bec-b082-5746db88af75/upload:0:level_1_test_5_stop_city.json.meta.json"
     *
     * The Git style commit is the 'version' field, if its empty the instance is not under version
     * control.
     *
     */

    html += `  <table class="blob-history-list">`;

    html += `  <thead><tr>`;
    html += `    <th>#</th>`;
    html += `    <th>Size</th>`;
    html += `    <th>Owner</th>`;
    html += `    <th>Modified</th>`;
    html += `    <th>OID</th>`;
    html += `  </tr></thead>`;

    html += `  <tbody>`;

    this.history.forEach((item: any) => {

      html += `    <tr>`;

      html += `      <td>${item.instance}</td>`;
      html += `      <td>${bytesToSize(item.size)}</td>`;
      html += `      <td>${item.owner}</td>`;
      html += `      <td>${item.modified}</td>`;
      html += `      <td>${item.oid}</td>`;

      html += `    </tr>`;
    });

    html += `  </tbody>`;

    html += `</table>`;

    html += `</div>`;

    /* render! */

    $(body).html(html);
  }

  /** dialog is closing */
  public close() {

    Logger.debug('[BlobHistoryDialog] closing...');
  }

  /** dialog was accepted */
  public ok() {

    Logger.debug('[BlobHistoryDialog] accepted.');

    if (this.success) {

      /* inform the client */

      this.success();
    }

  }
}
